import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import creditIcon from './../../img/credit-icon.svg';
import cardsIcon from './../../img/cards-icon.png';
import { request } from './../../../../config';
import Dropdown from './../../../../copms/Dropdown/Dropdown';
import CreditSchedule from './../../../../copms/Modal/CreditSchedule';
import CreditPayment from './../../../../copms/Modal/CreditPayments';
import { translate } from 'react-i18next';
import currencyFilter from './../../../../helpers/currencyFilter';
import Loading from './../../Loading/Loading';
import { TextField } from '@mui/material';
import lastOperationsIcon from '../../img/last-operations-icon.png';

class CreditsOther extends Component {
    state = {
        credits: [],
        openCreditSchedule: false,
        openCreditPayment: false,
        loanId: null,
        customerCode: '',
        isLoading: false
    }

    dropdownItemHandler = (index, credit) => {
        switch (index) {
            case 0:
                this.props.history.push(`/dashboard/finance/credits/other/pay/${credit.id}/${credit.iban}`, { credit });
                break;
            default: break;
        }
    }

    getLoansByCustomerCode = () => {
        this.setState({ isLoading: true });
        let loanRequestBody = {
            customerCode: this.state.customerCode,
            token: localStorage.getItem('token'),
            lang: localStorage.getItem('i18nextLng').toUpperCase()
        }
        fetch(request("loan/getLoansByCustomerCode", loanRequestBody))
            .then(res => res.text())
            .then((loanResponseJSON) => {
                const JSON = require('true-json-bigint');
                let loanResponse = JSON.parse(loanResponseJSON);
                if (loanResponse.status.statusCode !== 1 && loanResponse.status.statusCode !== 139) {
                    if (loanResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(loanResponse.status.statusCode));
                        this.setState({ isLoading: false });
                    }
                }
                else {
                    if (loanResponse.status.statusCode === 139) {
                        this.props.alertState(true, 'warning', null, this.props.t('Daxil edilən 13 rəqəmli kod üzrə aktiv kredit mövcud deyil'));
                        loanResponse.loans = [];
                    }
                    this.setState({ credits: loanResponse.loans ?? [] });
                    this.setState({ isLoading: false });
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    render() {
        let { credits, isLoading, customerCode } = this.state;
        let { t } = this.props;

        return (
            <>
                <div className="dashboard-header-route">
                    <div className="dashboard-header-route-left">
                        <button onClick={() => this.props.history.goBack()}>
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.7344 21.2188L12.6719 20.3281C12.9062 20.0938 12.9062 19.7188 12.6719 19.5312L5.40625 12.2188H21.4375C21.7188 12.2188 22 11.9844 22 11.6562V10.3438C22 10.0625 21.7188 9.78125 21.4375 9.78125H5.40625L12.6719 2.51562C12.9062 2.32812 12.9062 1.95312 12.6719 1.71875L11.7344 0.828125C11.5469 0.59375 11.1719 0.59375 10.9375 0.828125L1.14062 10.625C0.90625 10.8594 0.90625 11.1875 1.14062 11.4219L10.9375 21.2188C11.1719 21.4531 11.5469 21.4531 11.7344 21.2188Z" fill="#2E3131" />
                            </svg>
                        </button>
                        <h2>{t('TuranBank kreditləri')}</h2>
                    </div>
                </div>
                <div className="dashboard-salary-container">
                    <div className="dashboard-salary-container-data-section" style={{ marginTop: '1px' }}>
                        <div className="dashboard-salary-order-container">
                            <div className="dashboard-salary-order-container-box flex-start">
                                <div className="dashboard-salary-order-container-box-select">
                                    <TextField value={customerCode} inputProps={{ maxLength: 13 }} onChange={(e) => this.setState({ customerCode: e.target.value.replace(/[^0-9]/g, "") })} placeholder={t("Customer Code")} helperText={t('13 simvoldan ibarət olmalıdır')} />
                                </div>
                                <button style={{ height: '48px' }} className="dashboard-salary-order-container-box-button dashboard-salary-order-container-box-button-main" disabled={customerCode.length < 13 || isLoading} onClick={this.getLoansByCustomerCode}>{t("Search")}</button>
                            </div>
                            {isLoading ?
                                <Loading />
                                :
                                (credits.length === 0) ?
                                    <div className="dashboard-last-operations-section-content mt-5">
                                        <img src={lastOperationsIcon} className="dashboard-last-operations-section-content-image" alt="lastOperationsIcon" />
                                        <p className="dashboard-last-operations-section-content-status">{t('Aktiv kredit mövcud deyil')}</p>
                                    </div>
                                    :
                                    <table className="dashboard-finance-section-cards-section-table">
                                        <tbody className="dashboard-finance-section-cards-section-tbody">
                                            {credits.map((credit, index) =>
                                                <tr className="dashboard-finance-section-cards-section-row">
                                                    <td className="dashboard-finance-section-cards-section-cell">
                                                        <img src={creditIcon} className="dashboard-finance-section-cards-section-cell-icon" alt="creditIcon" />
                                                        <div className="dashboard-finance-section-cards-section-cell-main-section">
                                                            <p className="dashboard-finance-section-cards-section-cell-content">{credit.fullName}</p>
                                                            <p className="dashboard-finance-section-cards-section-cell-title">{credit.iban}</p>
                                                        </div>
                                                    </td>
                                                    {/* <td className="dashboard-finance-section-cards-section-cell">
                                                        <p className="dashboard-finance-section-cards-section-cell-content">{credit.iban}</p>
                                                        <p className="dashboard-finance-section-cards-section-cell-title">{t('Account')}</p>
                                                    </td> */}
                                                    <td className="dashboard-finance-section-cards-section-cell">
                                                        <p className="dashboard-finance-section-cards-section-cell-content">{credit.openDate}</p>
                                                        <p className="dashboard-finance-section-cards-section-cell-title">{t('Kredit tarixi')}</p>
                                                    </td>
                                                    <td className="dashboard-finance-section-cards-section-cell">
                                                        <p className="dashboard-finance-section-cards-section-cell-content">{credit.loanAmount}</p>
                                                        <p className="dashboard-finance-section-cards-section-cell-title">{t('Amount')}</p>
                                                    </td>
                                                    <td className="dashboard-finance-section-cards-section-cell">
                                                        <p className="dashboard-finance-section-cards-section-cell-content">{credit.paymentAmount}</p>
                                                        <p className="dashboard-finance-section-cards-section-cell-title">{t('Amount to be paid')}</p>
                                                    </td>
                                                    <td className="dashboard-finance-section-cards-section-cell">
                                                        <p className="dashboard-finance-section-cards-section-cell-content">{credit.currency}</p>
                                                        <p className="dashboard-finance-section-cards-section-cell-title">{t('currency')}</p>
                                                    </td>
                                                    <td className="dashboard-finance-section-cards-section-cell">
                                                        {
                                                            <div className="dashboard-finance-section-cards-section-button-group">
                                                                <Dropdown dropdownItems={[
                                                                    { title: this.props.t('make a payment') }
                                                                ]} dropdownItemHandler={(i) => this.dropdownItemHandler(i, credit)} />
                                                            </div>
                                                        }
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>

                            }
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default translate("translation")(CreditsOther);